import React from "react";
import PropTypes from "prop-types";

const InvalidFeedback = ({ name, validationErrors }) => {
  if (
    !(name in validationErrors) ||
    typeof validationErrors[name] === "undefined"
  ) {
    return null;
  }
  // console.log("ValidationErrors: ", validationErrors);
  return (
    <div className="invalid-feedback" style={{ display: "block" }}>
      {validationErrors[name].join(" ")}
    </div>
  );
};

InvalidFeedback.defaultProps = {
  validationErrors: {}
};

InvalidFeedback.propTypes = {
  validationErrors: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
  name: PropTypes.string.isRequired
};

export default InvalidFeedback;
